import { Action } from '@ngrx/store';

export enum TraceabilityActions {
    GetRecLotByRecLotId = '[Traceability] Get RecLot By RecLotId',
    GetRecLotByRecLotIdSuccess = '[Traceability] Get RecLot By RecLotId Success',
    GetRecLotByRecLotIdError = '[] Get RecLot By RecLotId Error',
    GetMLCByInternalCode = '[Traceability] Get MLC By InternalCode',
    GetMLCByInternalCodeSuccess = '[Traceability] Get MLC By InternalCode Success',
    GetMLCByInternalCodeError = '[] Get MLC By InternalCode Error',
    GetRecLotByMaterialId = '[Traceability] Get RecLot By MaterialId',
    GetRecLotByMaterialIdSuccess = '[Traceability] Get RecLot By MaterialId Success',
    GetRecLotByMaterialIdError = '[] Get RecLot By MaterialId Error',
    GetMLCsByFormulaId = '[Traceability] Get MLCs By FormulaId',
    GetMLCsByFormulaIdSuccess = '[Traceability] Get MLCs By FormulaId Success',
    GetMLCsByFormulaIdError = '[] Get MLCs By FormulaId Error',
    GetProductTraceability = '[Traceability] Get Product Traceability',
    GetProductTraceabilitySuccess = '[Traceability] Get Product Traceability Success',
    GetProductTraceabilityError = '[] Get Product Traceability Error',
    GetMaterialTraceability = '[Traceability] Get Material Traceability',
    GetMaterialTraceabilitySuccess = '[Traceability] Get Material Traceability Success',
    GetMaterialTraceabilityError = '[] Get Material Traceability Error',
}
export class GetRecLotByRecLotId implements Action {
    public readonly type = TraceabilityActions.GetRecLotByRecLotId;
    constructor(public payload: any) {
    }
}
export class GetRecLotByRecLotIdSuccess implements Action {
    public readonly type = TraceabilityActions.GetRecLotByRecLotIdSuccess;
    constructor(public payload: any) {
    }
}
export class GetRecLotByRecLotIdError implements Action {
    public readonly type = TraceabilityActions.GetRecLotByRecLotIdError;
    constructor(public payload: any) {
    }
}
export class GetMLCByInternalCode implements Action {
    public readonly type = TraceabilityActions.GetMLCByInternalCode;
    constructor(public payload: any) {
    }
}
export class GetMLCByInternalCodeSuccess implements Action {
    public readonly type = TraceabilityActions.GetMLCByInternalCodeSuccess;
    constructor(public payload: any) {
    }
}
export class GetMLCByInternalCodeError implements Action {
    public readonly type = TraceabilityActions.GetMLCByInternalCodeError;
    constructor(public payload: any) {
    }
}
export class GetRecLotByMaterialId implements Action {
    public readonly type = TraceabilityActions.GetRecLotByMaterialId;
    constructor(public payload: any) {
    }
}
export class GetRecLotByMaterialIdSuccess implements Action {
    public readonly type = TraceabilityActions.GetRecLotByMaterialIdSuccess;
    constructor(public payload: any) {
    }
}
export class GetRecLotByMaterialIdError implements Action {
    public readonly type = TraceabilityActions.GetRecLotByMaterialIdError;
    constructor(public payload: any) {
    }
}
export class GetMLCsByFormulaId implements Action {
    public readonly type = TraceabilityActions.GetMLCsByFormulaId;
    constructor(public payload: any) {
    }
}
export class GetMLCsByFormulaIdSuccess implements Action {
    public readonly type = TraceabilityActions.GetMLCsByFormulaIdSuccess;
    constructor(public payload: any) {
    }
}
export class GetMLCsByFormulaIdError implements Action {
    public readonly type = TraceabilityActions.GetMLCsByFormulaIdError;
    constructor(public payload: any) {
    }
}
export class GetMaterialTraceability implements Action {
    public readonly type = TraceabilityActions.GetMaterialTraceability;
    constructor(public payload: any) {
    }
}
export class GetMaterialTraceabilitySuccess implements Action {
    public readonly type = TraceabilityActions.GetMaterialTraceabilitySuccess;
    constructor(public payload: any) {
    }
}
export class GetMaterialTraceabilityError implements Action {
    public readonly type = TraceabilityActions.GetMaterialTraceabilityError;
    constructor(public payload: any) {
    }
}
export class GetProductTraceability implements Action {
    public readonly type = TraceabilityActions.GetProductTraceability;
    constructor(public payload: any) {
    }
}
export class GetProductTraceabilitySuccess implements Action {
    public readonly type = TraceabilityActions.GetProductTraceabilitySuccess;
    constructor(public payload: any) {
    }
}
export class GetProductTraceabilityError implements Action {
    public readonly type = TraceabilityActions.GetProductTraceabilityError;
    constructor(public payload: any) {
    }
}

export type TraceabilityAction = GetMLCByInternalCode | GetMLCByInternalCodeSuccess | GetMLCByInternalCodeError |
                GetRecLotByRecLotId |GetRecLotByRecLotIdSuccess | GetRecLotByRecLotIdError|
                GetMLCsByFormulaId|GetMLCsByFormulaIdSuccess|GetMLCsByFormulaIdError|GetRecLotByMaterialId|
                GetRecLotByMaterialIdSuccess|GetRecLotByMaterialIdError|GetProductTraceability|GetProductTraceabilitySuccess|
                GetProductTraceabilityError|GetMaterialTraceability|GetMaterialTraceabilitySuccess|GetMaterialTraceabilityError;
